export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Search form
    const searchEventsForm = $('.search-events');
    if (searchEventsForm.length) {
      const submitButton = searchEventsForm.find('button[type="submit"]');

      searchEventsForm.find('.where, .occasion, .guest')
        .on('input', function() {
          const _this = $(this);

          if (_this.val().length === 0) {
            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          submitButton.prop('disabled', false);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventPage.js